// Sezioni cavi disponibili
export const SEZIONI = [
    { val: 0.25, dia: 0.6, back1: 0.1, clampGapL: 1.5, clampGapR: 1.5, wordSize: 0 },
    { val: 0.5, dia: 0.8, back1: 0.1, clampGapL: 2, clampGapR: 2, wordSize: 1 },
    { val: 0.75, dia: 1, back1: 0.2, clampGapL: 2, clampGapR: 2, wordSize: 1 },
    { val: 1.0, dia: 1.2, back1: 0.2, clampGapL: 2, clampGapR: 2, wordSize: 2 },
    { val: 1.5, dia: 1.4, back1: 0.2, clampGapL: 2.5, clampGapR: 2.5, wordSize: 3 },
    { val: 2.5, dia: 1.8, back1: 0.3, clampGapL: 2.5, clampGapR: 2.5, wordSize: 4 },
    { val: 4, dia: 2.3, back1: 0.3, clampGapL: 3, clampGapR: 3, wordSize: 5 },
    { val: 6, dia: 2.8, back1: 0.3, clampGapL: 3.5, clampGapR: 3.5, wordSize: 6 },
    { val: 10, dia: '', back1: '', clampGapL: '', clampGapR: '', wordSize: '' }
];

// Sezioni AWG disponibili
export const SEZIONI_AWG = [
    { val: 23, metric: 0.25, dia: 0.6, back1: 0.1, clampGapL: 1.5, clampGapR: 1.5, wordSize: 0 },
    { val: 20, metric: 0.5, dia: 0.8, back1: 0.1, clampGapL: 2, clampGapR: 2, wordSize: 1 },
    { val: 18, metric: 0.75, dia: 1, back1: 0.2, clampGapL: 2, clampGapR: 2, wordSize: 1 },
    { val: 17, metric: 1.0, dia: 1.2, back1: 0.2, clampGapL: 2, clampGapR: 2, wordSize: 2 },
    { val: 16, metric: 1.5, dia: 1.3, back1: 0.3, clampGapL: 2.5, clampGapR: 2.5, wordSize: 3 },
    { val: 14, metric: 2.5, dia: 1.7, back1: 0.3, clampGapL: 3, clampGapR: 3, wordSize: 4 },
    { val: 12, metric: 4, dia: 2.1, back1: 0.3, clampGapL: 3.5, clampGapR: 3.5, wordSize: 5 },
    { val: 10, metric: 6, dia: 2.6, back1: 0.3, clampGapL: 4, clampGapR: 4, wordSize: 6 },
    { val: 8,  metric: 10, dia: '', back1: '', clampGapL: '', clampGapR: '', wordSize: '' }
];